'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const isHtmlElement = require('./is-html-element.js');

function contains(parent, child) {
  if (!parent || !child)
    return false;
  if (!isHtmlElement.isHTMLElement(parent) || !isHtmlElement.isHTMLElement(child))
    return false;
  return parent === child || parent.contains(child);
}
const isSelfEvent = (event) => contains(event.currentTarget, event.target);

exports.contains = contains;
exports.isSelfEvent = isSelfEvent;
